module.exports = __webpack_public_path__ + "static/img/logo.e275beb.png";


//////////////////
// WEBPACK FOOTER
// ./image/homePage/logo.png
// module id = 269
// module chunks = 502